@use "@fukuri-admins/ui/layout" as *;

// 確認ダイアログの内側に置く編集フォーム。ダイアログ本体（.dialog）と同じ縦方向の間隔で並べる
// onSubmit を受ける <form> 要素が必要で、Stack（div を描画し属性を透過しない）では置き換えられないため div + flex で実装
.form {
  display: flex;
  flex-direction: column;
  gap: spacing("24");
  // ダイアログ本体（min-height 指定）いっぱいに広げ、確認ビューとフッターの位置を揃える
  flex: 1;
  min-height: 0;
}

.title {
  @include typography('Jp/16_W6');
  color: text('High');
}

// ダイアログ本体は max-height: 90vh のため、低い画面ではフォーム部分だけを縦スクロールさせる（確認ビューの .content と同じ）
.content {
  flex: 1;
  overflow-y: auto;
}

.groupLabel {
  @include typography('Jp/14_W6');
  color: text('High');
  margin: 0;
}

// 利用人数・郵便番号は短い入力なので幅を絞る（Figma 準拠）
.employeeCountField,
.postalCodeField {
  width: 168px;
}

.prefectureField {
  width: 168px;
  flex-shrink: 0;
}

.cityField,
.streetAddressField {
  width: 548px;
  max-width: 100%;
}
